import {
  Field,
  RangePicker,
  Filter,
  Text,
  TimePicker,
} from "components/commons";
import React, { useCallback } from "react";
import lang from "translations";
import { modifyFromTimeRange, modifyToTimeRange } from "services";

const VoucherTransactionReportFilter = ({
  filterState,
  requestState,
  modifyFilter,
  clearFilter,
  onClear,
  onApply,
}) => {
 
  const applyFilterCb = useCallback(
    async (searchKey) => {
      await onApply(searchKey);
    },
    [onApply]
  );

  const clearFilterCb = useCallback(() => {
    const { filterState, requestState } = clearFilter();
    onClear(filterState, requestState);
  }, [clearFilter, onClear]);

  const changeDateRangeCb = useCallback(
    (name, value) => {
     modifyFilter(name, { value });
    },
    [modifyFilter]
  );

  return (
    <div>
      <Filter
        onClear={clearFilterCb}
        onApply={applyFilterCb}
        dateRange={filterState.dateRange}
        span={12}
        searchBox={true}
      >
        <Field filterLabel={lang.dateRange} className="col-span-4">
          <RangePicker
            name="dateRange"
            onChange={changeDateRangeCb}
            value={filterState.dateRange}
          />
        </Field>
        <Field filterLabel={lang.timeRange} className="col-span-4">
          <div className="flex items-center">
            <TimePicker
              value={filterState.dateRange[0]}
              onChange={(val) => {
                modifyFromTimeRange(val, filterState, modifyFilter);
              }}
            />
            <Text className="mx-sm" color="text-black-light">
              to
            </Text>
            <TimePicker
              value={filterState.dateRange[1]}
              onChange={(val) => {
                modifyToTimeRange(val, filterState, modifyFilter);
              }}
            />
          </div>
        </Field>
      </Filter>
    </div>
  );
};

export default VoucherTransactionReportFilter;
